import DashboardTabs from './Tabs';

export default DashboardTabs;
